import { InfoCircleOutlined } from '@ant-design/icons';
import { List, Popover, Space, Switch, theme, Typography } from 'antd';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { GrispiDateInputProps } from './components/GrispiDateInput';

export const GRISPI_ANNIVERSARY_KEY = 'ANNIVERSARY:';
export const notAnniversaryOperatorsMap = [
    'PRESENT',
    'NOT_PRESENT',
    'SINCE_YESTERDAY',
    'PREVIOUS_YEAR',
    'NEXT_YEAR',
    'CHANGED',
    'NOT_CHANGED'
];
const GrispiInputAnniversaryController = ({
    value,
    onChange,
    children,
    operator,
    disabled
}: PropsWithChildren<Pick<GrispiDateInputProps, 'value' | 'onChange'> & { operator?: string; disabled?: boolean }>) => {
    const {
        token: { paddingXXS, zIndexPopupBase }
    } = theme.useToken();
    const { t } = useTranslation('admin');
    const handleChange = (checked: boolean) => {
        if (checked) {
            if (!value?.includes(GRISPI_ANNIVERSARY_KEY)) {
                onChange && onChange(`${GRISPI_ANNIVERSARY_KEY}${value?.toString() ?? 'null'}`);
            }
        } else {
            onChange && onChange(value?.replace(GRISPI_ANNIVERSARY_KEY, ''));
        }
    };

    return (
        <List bordered>
            {children}
            <Space
                size="small"
                className="full-width"
                style={{ display: 'flex', justifyContent: 'end', padding: paddingXXS }}
            >
                <Popover
                    placement="top"
                    content={<Typography.Text type="secondary">{t('anniversary.information')}</Typography.Text>}
                    trigger="hover"
                    overlayStyle={{ fontSize: 13, width: 300 }}
                    zIndex={zIndexPopupBase + 30 + 2} // zIndexPopupBase + 30 (default popover z-index) + 2 (place over PluginApp component)
                >
                    <Space>
                        <InfoCircleOutlined />
                    </Space>
                </Popover>
                <Typography.Text>{t('anniversary.title')}</Typography.Text>
                <Switch
                    defaultChecked={value?.includes(GRISPI_ANNIVERSARY_KEY)}
                    onChange={handleChange}
                    size="small"
                    disabled={disabled || (operator ? false : !value)}
                />
            </Space>
        </List>
    );
};

export default GrispiInputAnniversaryController;

// return (
//     <Space.Compact>
//         {children}
//         <Popover
//             placement="bottomRight"
//             content={
//                 <Space size="small" className="full-width">
//                     <Typography.Text type="secondary">Anniversary</Typography.Text>
//                     <Switch checked={value?.includes(GRISPI_ANNIVERSARY_KEY)} onChange={handleChange} />
//                 </Space>
//             }
//             trigger="hover"
//         >
//             <Button icon={<SettingOutlined />} />
//         </Popover>
//     </Space.Compact>
// );
